
import { Directive, ElementRef, HostListener } from '@angular/core';
@Directive({
  selector: '[appNoSpaces]'
})
export class NoSpacesDirective {

  constructor(private el: ElementRef) {}

  @HostListener('blur') // Triggered when the input loses focus
  onBlur() {
    const trimmedValue = this.el.nativeElement.value.trim();
    this.el.nativeElement.value = trimmedValue;
  }

  @HostListener('input') // Triggered when the user types
  onInput() {
    const trimmedValue = this.el.nativeElement.value.trim();
    this.el.nativeElement.value = trimmedValue;
  }

}
